import mitt from 'mitt';

export const CURRENT_COUNTRY_CHANGED = 'currentCountryChanged';
export const OPEN_ACCOUNT_POPOVER = 'openAccountPopover';
export const CURRENT_USER_IS_LOGGED = 'currentUserIsLogged';

export const emitter = mitt();
